module.exports = __webpack_public_path__ + "static/media/ic-none-profile.b84187a2.svg";